module.exports = __webpack_public_path__ + "static/media/attachment.b82faf73.svg";